import React, { Component } from 'react';
import Helmet from 'react-helmet';
import * as str from '../lib/string_utils';

export default class PageMeta extends Component {
  render() {
    const defaults = {
      title: 'Updox',
      titleTemplate: '%s | Updox',
      description: 'Updox is much amaze, very wow',
      url: window.location.href,
      imageUrl: 'https://s3.amazonaws.com/media.updox/defaults/share-default.jpeg',
      videoUrl: null,
      locale: 'en_us',
      type: 'website',
      twitterSite: '@updox',
      httpStatusCode: 200,
      jsonLd: {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        name: 'Updox',
        url: 'https://www.updox',
      },
      script: [],
      link: [],
      meta: [],
    };

    const metaProps = { ...defaults, ...this.props };

    let meta = [
      {
        name: 'description',
        content: str.ellipsis(metaProps.description, 160),
      },
      {
        property: 'og:url',
        content: metaProps.url,
      },
      {
        property: 'og:title',
        content: metaProps.title,
      },
      {
        property: 'og:image',
        content: metaProps.imageUrl,
      },
      {
        property: 'og:description',
        content: str.ellipsis(metaProps.description, 160),
      },
      {
        property: 'og:locale',
        content: metaProps.locale,
      },
      {
        name: 'twitter:card',
        content: metaProps.twitterCard,
      },
      {
        name: 'twitter:description',
        content: str.ellipsis(metaProps.description, 160),
      },
      {
        name: 'twitter:title',
        content: metaProps.title,
      },
    ];

    if (metaProps.httpStatusCode) {
      meta.push({
        name: 'prerender-status-code',
        content: metaProps.httpStatusCode,
      });
    }

    if (metaProps.videoUrl) {
      meta.push({
        property: 'og:video',
        content: metaProps.videoUrl,
      });
    }

    metaProps.script.push({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(metaProps.jsonLd),
    });

    if (metaProps.feedUrl) {
      metaProps.link.push({
        rel: 'alternate',
        type: 'application/rss+xml',
        title: metaProps.feedTitle || 'RSS 2.0 Feed',
        href: metaProps.feedUrl,
      });
    }

    meta = meta.concat(metaProps.meta);

    return (
      <Helmet
        titleTemplate={metaProps.titleTemplate}
        title={metaProps.title}
        script={metaProps.script}
        meta={meta}
        link={metaProps.link}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PageMeta.js